import { render, staticRenderFns } from "./closedSession.vue?vue&type=template&id=34b4ccb6&scoped=true"
import script from "./closedSession.vue?vue&type=script&lang=js"
export * from "./closedSession.vue?vue&type=script&lang=js"
import style0 from "./closedSession.vue?vue&type=style&index=0&id=34b4ccb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4ccb6",
  null
  
)

export default component.exports